import moment from 'moment';
import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Form as FinalForm, Field } from 'react-final-form';
import { Form, Grid, Modal } from 'semantic-ui-react';

// Actions
import {
    requestCreateTimesheet
    // @ts-ignore
} from 'services/timesheet/actions';

// Global Components
// @ts-ignore
import ErrorAlert from 'components/ErrorAlert';
// @ts-ignore
import EntityOptions from 'components/EntityOptions';

// Form
import { normalizers, RenderTextArea, validators, RenderDropdown } from 'forms';

// Types
import { AppState } from 'services/types';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import PeopleDropdown from 'components/PeopleDropdown';
import QueryStringModal from 'components/QueryStringModal';
import WeekDropdown from 'components/WeekDropdown';

// Local Selectors
import SubmittingSection from 'components/SubmissionSection';
import { selectInitialValues } from './selectors';

// Normalizers
const { toNull } = normalizers;

// Validator
const { isRequired } = validators;

// Constants
const NAMESPACE = ['TIMESHEET_CREATE', 'TIMESHEET_UPDATE'];
const QUERY_STRING_PARAM = 'individualTimesheetModal';

// Types
interface ConnectedProps {
    initialValues?: Record<string, any>;
}

interface DispatchProps {
    requestCreateTimesheet: Function;
}

type Props = ConnectedProps & DispatchProps;

export class IndividualTimesheetModal extends React.PureComponent<Props> {
    handleSubmit = (values: any): void => {
        const { weekDate, ...timesheet } = values;
        const startDate = weekDate;
        const endDate = moment(weekDate, 'YYYY-MM-DD')
            .add(6, 'days')
            .format('YYYY-MM-DD');

        this.props.requestCreateTimesheet({
            ...timesheet,
            startDate,
            endDate
        });
    };

    render(): React.ReactElement {
        const { initialValues } = this.props;

        return (
            <QueryStringModal param={QUERY_STRING_PARAM}>
                <ErrorBoundary
                    namespace="IndividualTimesheetModal"
                    FallbackComponent={<ErrorBoundaryAlert />}
                >
                    <Modal.Header>Create Person Timesheet</Modal.Header>
                    <Modal.Content className="constrain-width">
                        <FinalForm
                            onSubmit={this.handleSubmit}
                            subscription={{}}
                            initialValues={initialValues}
                            render={(props: any): any => {
                                const { handleSubmit } = props;

                                return (
                                    <Form
                                        autoComplete="off"
                                        onSubmit={handleSubmit}
                                    >
                                        <Grid className="column-padding">
                                            <Grid.Row>
                                                <Grid.Column width={16}>
                                                    <WeekDropdown
                                                        name="weekDate"
                                                        validate={isRequired}
                                                    />
                                                </Grid.Column>
                                                <Grid.Column width={16}>
                                                    <PeopleDropdown
                                                        name="personId"
                                                        validate={isRequired}
                                                    />
                                                </Grid.Column>
                                                <Grid.Column width={16}>
                                                    <EntityOptions>
                                                        {(
                                                            options: any
                                                        ): React.ReactElement => (
                                                            <Field
                                                                component={
                                                                    RenderDropdown as any
                                                                }
                                                                subscription={{
                                                                    value: true,
                                                                    touched:
                                                                        true,
                                                                    error: true
                                                                }}
                                                                options={
                                                                    options
                                                                }
                                                                name="entityId"
                                                                label="Area"
                                                                placeholder="Add area"
                                                                fluid
                                                                search
                                                                selection
                                                                clearable
                                                                selectOnBlur={
                                                                    false
                                                                }
                                                                validate={
                                                                    isRequired
                                                                }
                                                            />
                                                        )}
                                                    </EntityOptions>
                                                </Grid.Column>
                                                <Grid.Column width={16}>
                                                    <Field
                                                        name="comment"
                                                        component={
                                                            RenderTextArea as any
                                                        }
                                                        subscription={{
                                                            value: true,
                                                            touched: true,
                                                            error: true
                                                        }}
                                                        label="Comment (optional)"
                                                        type="text"
                                                        placeholder="Enter comment"
                                                        parse={toNull}
                                                    />
                                                </Grid.Column>
                                            </Grid.Row>
                                        </Grid>
                                        <ErrorAlert namespace={NAMESPACE} />
                                        <SubmittingSection
                                            queryStringCancelButtonParam={{
                                                params: {
                                                    [QUERY_STRING_PARAM]:
                                                        undefined
                                                }
                                            }}
                                            submittingButtonParam={{
                                                namespace: NAMESPACE
                                            }}
                                        />
                                    </Form>
                                );
                            }}
                        />
                    </Modal.Content>
                </ErrorBoundary>
            </QueryStringModal>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    initialValues: selectInitialValues
});

export default connect(mapStateToProps, {
    requestCreateTimesheet
})(IndividualTimesheetModal);
